import {call, takeLatest, put} from 'redux-saga/effects'
import graphql from 'services/graphql'
import api from 'services/api'
import {
  errorMessageFromGraphQL,
  successMessage,
  warningMessage,
  deletedMessage,
  savedMessage
} from 'config/toast'

import {
  FAILED_GET_PRODUCT,
  FAILED_GET_PRODUCTS,
  FAILED_PERSIST_PRODUCT,
  FAILED_DELETE_PRODUCT,
  RECEIVE_GET_PRODUCT,
  RECEIVE_GET_PRODUCTS,
  RECEIVE_PERSIST_PRODUCT,
  RECEIVE_DELETE_PRODUCT,
  REQUEST_GET_PRODUCT,
  REQUEST_GET_PRODUCT_LIST,
  REQUEST_GET_PRODUCTS,
  REQUEST_PERSIST_PRODUCT,
  REQUEST_DELETE_PRODUCT,
} from 'redux/actions/product'

import { NOTIFY } from 'redux/actions/notification'

import {
  PRODUCT_QUERY,
  PRODUCT_LIST_QUERY,
  PRODUCTS_QUERY
} from 'graphql/queries/product'
import {PRODUCT_MUTATION} from 'graphql/mutations/product'

function* getProduct(action) {
  try {
    const data = yield call(graphql.query, PRODUCT_QUERY, { id: action.id })

    yield put({ type: RECEIVE_GET_PRODUCT, data: data.product })
  } catch(error) {
    yield put({ type: FAILED_GET_PRODUCT, error })

    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* getProductList(action) {
  try {
    const data = yield call(graphql.query, PRODUCT_LIST_QUERY, {
      ...(action.filters ? { filters: action.filters } : {}),
    })

    yield put({
      type: RECEIVE_GET_PRODUCTS,
      data: data.productList,
      pageNumber: 0,
      totalCount: 0,
    })
  } catch(error) {
    yield put({ type: FAILED_GET_PRODUCTS, error })

    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* getProducts(action) {
  try {
    const data = yield call(graphql.query, PRODUCTS_QUERY, {
      pageNumber: action.pageNumber,
      pageSize: action.pageSize,
      ...(action.filters ? { filters: action.filters } : {}),
      ...(action.sorting ? { sorting: action.sorting } : {}),
    })

    yield put({
      type: RECEIVE_GET_PRODUCTS,
      data: data.products.data,
      pageNumber: action.pageNumber,
      totalCount: data.products.total,
    })
  } catch(error) {
    yield put({ type: FAILED_GET_PRODUCTS, error })

    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* persistProduct(action) {
  try {
    delete action.data.__typename

    const data = yield call(graphql.mutate, PRODUCT_MUTATION, action.data)

    yield put({
      type: RECEIVE_PERSIST_PRODUCT,
      data: data.product,
    })

    const notification = successMessage(savedMessage('product'))
    yield put({ type: NOTIFY, notification })
  } catch(error) {
    yield put({ type: FAILED_PERSIST_PRODUCT, error })

    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* deleteProduct(action) {
  try {
    yield call(api.delete, `/product/${action.id}`)

    const notification = successMessage(savedMessage('product'))
    yield put({ type: NOTIFY, notification })
  } catch(error) {
    yield put({ type: FAILED_DELETE_PRODUCT, error })
  }
}

export default function* root() {
  yield takeLatest(REQUEST_GET_PRODUCT, getProduct)
  yield takeLatest(REQUEST_GET_PRODUCT_LIST, getProductList)
  yield takeLatest(REQUEST_GET_PRODUCTS, getProducts)
  yield takeLatest(REQUEST_PERSIST_PRODUCT, persistProduct)
  yield takeLatest(REQUEST_DELETE_PRODUCT, deleteProduct)
}
